
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import { mapState, mapMutations } from "vuex";
import { doWithdraw, withdrawInfo, doBankWithdraw } from "../service/getdata";
export default {
components: {
XHeader,
Toast,
},
data() {
return {
show: "",
msg: "",
amount: "",
bankName: "",
bankCard: "",
name: "",
selectedType: "",
withdrawInfo: {},
coin: "USD", //选中提的币种
bankType: [],
showSymbol: false, //底部选择币种弹出框的展示隐藏

symbol: "USD",
money: "",
paywd: "",
bank_name: "",
bank_card: "",
real_name: "",
input_type: "password",
};
},
created() {
this.SETTOKEN();
this.getData();
},
computed: {
...mapState(["token"]),
},
methods: {
...mapMutations(["SETTOKEN"]),
getData() {
var that = this;
this.$Loading();
withdrawInfo({ token: this.token }).then(
function (res) {
var res = res.data;
that.$Loading.close();
if (res.status == "1" || res.status == "0") {
that.withdrawInfo = res.data;
that.bankType = res.data.bank_type.map((i) => {
return { name: i };
});
console.log('看看这个',that.bankType);
} else if (res.status == "-1") {
that.$router.push("/pages/relogin");
}
}.bind(this),
function () {
that.$Loading.close();
console.log("error");
}
);
},
onSelect(item) {
this.showSymbol = false;
this.symbol = item.name;
},
setMax() {

},
showTypeSelect() {

},
submit() {
this.$Loading();

let { bank_name, real_name, bank_card, money, symbol, paywd } =
this;

if (!bank_name) {
this.sendMsg(this.$t("请输入") + this.$t("银行名称"));
return;
}
if (!real_name) {
this.sendMsg(this.$t("请输入") + this.$t("姓名"));
return;
}
if (!bank_card) {
this.sendMsg(this.$t("请输入") + this.$t("银行卡号"));
return;
}
if (!money) {
this.sendMsg(this.$t("请输入") + this.$t("金额"));
return;
}
if (!symbol) {
this.sendMsg(this.$t("请选择") + this.$t("币种"));
return;
}
if (!paywd) {
this.sendMsg(this.$t("请输入") + this.$t("支付密码"));
return;
}


doBankWithdraw({
bank_name,
real_name,
bank_card,
money,
symbol,
paywd,
type: "bank",
token: this.token,
uid: window.localStorage.getItem("uid"),
})
.then((res) => {
var res = res.data;

if (res.status == "1") {
this.$vux.alert.show({
title: this.$t("提示"),
content: res.message,
buttonText: this.$t("确定"),
onHide: () => {
this.$router.push("/pages/moneyLog?history=2");
},
});
} else if (res.status == "-1") {

} else {
this.sendMsg(res.message);
}
})
.finally(() => {
this.$Loading.close();
});
},
sendMsg(content) {
this.msg = content;
this.show = true;
},
},
};



// WEBPACK FOOTER //
// ./src/pages/bank.vue